module.exports = __webpack_public_path__ + "static/media/montgomery.41e1d4dd.png";